import PrimaryButton from '../../components/PrimaryButton/PrimaryButton';
import SecondaryButton from '../../components/SecondaryButton/SecondaryButton';
import ParentalConsentWarning from '../../components/ParentalConsentWarning/ParentalConsentWarning';
import styles from '../../SCSS/Students.module.scss';
import { AddStudentModeType } from '@peekapak/types/DataProtocolTypes';

interface Props {
  onAddStudents?: () => void;
  onUpdateAddStudentMode?: (mode: AddStudentModeType) => void;
  isMiddleSchool?: boolean;
}

const EmptyClassMessage = ({ onAddStudents, onUpdateAddStudentMode, isMiddleSchool }: Props) => {
  return (
    <div className={styles.emptyClassMessage}>
      <div className={styles['spacer-40']} />
      <div className={styles.EmptyStatusMessage}>There are no students registered for this classroom</div>
      {onAddStudents && (
        <div className={styles.emptyButtonSection}>
          <PrimaryButton className={styles.addStudentsButton} onClick={onAddStudents}>
            + Add Students
          </PrimaryButton>

          {!isMiddleSchool && (
            <>
              <div className={styles.or}>or</div>
              <SecondaryButton small onClick={() => onUpdateAddStudentMode(AddStudentModeType.CLASS_CODE)}>
                Switch to Class Code Mode
              </SecondaryButton>
            </>
          )}
          <ParentalConsentWarning moreStyles={styles.parentalConsentWarning} />
        </div>
      )}
      <div className={styles['spacer-40']} />
    </div>
  );
};

export default EmptyClassMessage;
